import { useEffect, useState } from "react";
/* MATERIAL COMPONENTS */
import { CircularProgress } from "@mui/material";

import DashConsumoContratual from "../../components/classes/DashConsumoContratual";
import DashConsumoContratualDataset from "../../components/data/DashConsumoContratualDataSet";

/*STYLES*/
import "../../assets/css/dashboard_styles.css";

import EscolherFiltroDashboard from "../../components/common/EscolherFiltroDashboard/EscolherFiltroDashboard";
import DashboardConsumoCharts from "./dashboard";

export default function DashboardConsumoDetalhe() {
  // STATES
  const [dashConsumoContratualData, setDashConsumoContratualData] =
    useState<DashConsumoContratual[]>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [filtro, setFiltro] = useState<{
    isTrimestral: boolean;
    dataInicio: Date;
    dataFim: Date;
    idParceiro?: number;
    idProjeto?: number;
  }>();

  // DATA
  const dashConsumoContratualDataset = new DashConsumoContratualDataset();

  // useEffect(() => {
  //   if (filtro) {
  //     dashConsumoContratualDataset
  //       .getAll(
  //         filtro.isTrimestral!,
  //         filtro.dataInicio!,
  //         filtro.dataFim!,
  //         filtro.idParceiro,
  //         //filtro.idProjeto
  //       )
  //       .then((result) => {
  //         setDashConsumoContratualData(result);
  //         setIsLoading(false);
  //       });
  //   }
  // }, [filtro]);

  return (
    <>
      <div>
        <DashboardConsumoCharts></DashboardConsumoCharts>
      </div>
    </>
  );
}
